import {Box, Typography} from "@mui/material";

export const CardIQ = (
    {
        title,
        count,
        sideColor,
        keyFilter,
        dotColor,
        percentage,
        subTitle,
        onFilterCard
    }: {
    title: string;
    count: number;
    sideColor: string;
    onFilterCard: (key: string) => void;
    keyFilter: string;
    dotColor?: string;
    percentage?: string;
    subTitle?: string;
}) => {
    return (

        <Box
            sx={{
                position: 'relative',
                border: '1px solid #eee',
                borderRadius: 1,
                width: 180,
                p: 1,
                mr: 2,
                mb: 2,
                mt: 2,
                backgroundColor: '#fff',
                cursor: 'pointer',
            }}
            onClick={() => onFilterCard(keyFilter)}
        >
            <Box
                sx={{
                    backgroundColor: sideColor,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 6,
                    borderTopLeftRadius: 4,
                    borderBottomLeftRadius: 4,
                }}
            />

            <Box sx={{ ml: 2 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#555' }}>
                        {title}
                    </Typography>

                    {dotColor && (
                        <Box
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: dotColor,
                            }}
                        />
                    )}

                    {percentage && (
                        <Typography variant="caption" sx={{ color: '#999' }}>
                            {percentage} %
                        </Typography>
                    )}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                    }}
                >

                    <Typography
                        variant="h4"
                        sx={{ fontWeight: 'bold', color: sideColor }}
                    >
                        {count}
                    </Typography>

                    {subTitle && (
                        <Typography variant="body2" sx={{ color: '#999' }}>
                            {subTitle}
                        </Typography>
                    )}
                </Box>


            </Box>
        </Box>
    );
}